"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChartIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const PieChartIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 30 30" }),
    react_1.default.createElement("path", { d: "M14,15.936V2.032c0,0-0.029-0.004-0.056-0.004c-7.715,0-13.957,6.254-13.957,13.969c0,7.717,6.261,13.921,13.976,13.921   c7.703,0,13.955-5.982,13.975-13.982H14z" }),
    react_1.default.createElement("path", { d: "M29.938,13.936c0,0-0.024,0.025-0.024,0.012C29.914,6.26,24,0.076,16,0.032v13.903H29.938z" })));
exports.PieChartIcon = PieChartIcon;
exports.default = exports.PieChartIcon;
